import { render, staticRenderFns } from "./consultation.vue?vue&type=template&id=5815725a&scoped=true&"
import script from "./consultation.vue?vue&type=script&lang=js&"
export * from "./consultation.vue?vue&type=script&lang=js&"
import style0 from "./consultation.vue?vue&type=style&index=0&id=5815725a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5815725a",
  null
  
)

component.options.__file = "consultation.vue"
export default component.exports